// Function to create the user in the backend
export const createUser = async (email) => {
    try {
        const response = await fetch(`https://trendhopper-c3934b7293e6.herokuapp.com/user/by-email/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      return data.user_id; // Assuming the response contains a user_id
    } catch (error) {
      console.error('Error creating user:', error);
      return null;
    }
  };

  // Function to store the URL in the backend
  export const saveUrl = async (url, userId) => {
    console.log(url, userId)
    try {
        const response = await fetch(`https://trendhopper-c3934b7293e6.herokuapp.com/create-blog/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          url,
          user_id: userId,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error:', errorData);

        // Handle specific errors (you might want to throw custom errors here)
        if (errorData.error === 'Enter a valid URL.') {
          throw new Error('Invalid URL');
        }

        // Handle duplicate URL error
        if (errorData.error === 'This user already has a blog with the given URL.') {
            throw new Error('This user already has a blog with the given URL.');
        }

        throw new Error('An error occurred while saving the blog.');
      }

      const data = await response.json();
      console.log('Blog URL saved:', data);

      return true;

    } catch (error) {
      console.error('Error saving URL:', error);
      throw error; // Re-throw the error to be handled in handleUrlSubmit
    }
  };
